<template>
  <div class="page">
    <div class="sidebar">
      <div class="img">
        <img width="220px" src="@/assets/gis/caso.png" alt="" />
      </div>
      <div class="list">
        <!-- 用户信息 -->
        <div v-if="userInfo" style="padding: 20px; color: #fff">
          <div>当前账号:{{ userInfo?.email || userInfo?.userName }}</div>
        </div>

        <!-- [新增] 全局届数选择 -->
        <div class="match-select-wrapper">
          <el-select
            v-model="matchVersion"
            placeholder="请选择届数"
            class="match-select"
          >
            <el-option
              v-for="item in matchVersionList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            >
            </el-option>
          </el-select>
        </div>

        <!-- 菜单组 -->
        <div class="query">
          <img src="@/assets/gis/add.png" alt="" />
          <span>报名信息管理</span>
        </div>
        <!-- 管理员不再显示报名列表/审核菜单 -->
        <router-link to="/signList" v-if="userInfo?.type !== 9">
          <div class="menu-item">
            <span>
              报名列表(论文上报)
              <p class="tip">
                <i class="el-icon-warning-outline"></i>需观测满30天后可以上传
              </p>
            </span>
          </div>
        </router-link>

        <!-- 专家评审：管理员（9）和专家（91）可见 -->
        <router-link
          to="/review"
          v-if="userInfo?.type === 9 || userInfo?.type === 91"
        >
          <div class="menu-item">
            <span>专家评审</span>
          </div>
        </router-link>

        <!-- 以下菜单仅对非管理员开放 -->
        <template v-if="userInfo?.type !== 9">
          <router-link to="/info">
            <div class="menu-item">
              <span>参加比赛</span>
            </div>
          </router-link>
          <router-link to="/templates">
            <div class="menu-item history">
              <span>模板下载</span>
            </div>
          </router-link>
        </template>

        <!-- 气象数据上报：管理员不显示 -->
        <template v-if="showReport && userInfo?.type !== 9">
          <div class="query">
            <img src="@/assets/gis/add.png" alt="" />
            <span>气象数据上报</span>
          </div>
          <router-link to="/uploadData">
            <div class="menu-item history">
              <span>查看每日数据</span>
            </div>
          </router-link>
        </template>
      </div>
    </div>
    <div class="content-container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
// [新增] 导入 Vuex 辅助函数
import { mapGetters, mapState } from "vuex";

export default {
  name: "AppLayout",
  data() {
    return {
      showReport: true, // [优化] 默认值改为 false
    };
  },
  // [新增] Vuex 计算属性
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
    // 1. 从 'match' 模块获取届数列表
    ...mapGetters("match", ["matchVersionList"]),

    // 2. 创建 'matchVersion' (get/set) 与 Vuex store 双向绑定
    matchVersion: {
      get() {
        return this.$store.getters["match/currentMatchVersion"];
      },
      set(newValue) {
        this.$store.dispatch("match/updateMatchVersion", newValue);
      },
    },
  },
  created() {
    this.$store.dispatch("match/fetchMatchVersionList");
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.page {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: flex-start;
  .sidebar {
    flex-shrink: 0;
    padding: 65px 20px 20px 20px;
    width: 320px;
    min-height: 100vh;
    background: linear-gradient(0deg, #31b2a0 0%, #00a8d8 100%);
    display: flex;
    flex-direction: column;
    .img {
      width: 280px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    /* [新增] 下拉框样式 */
    .match-select-wrapper {
      padding: 10px 0;
      display: flex;
      justify-content: center;
      .match-select {
        width: 280px;
        /deep/ .el-input__inner {
          background-color: rgba(255, 255, 255, 0.9);
          color: #00325f;
          font-size: 18px;
          font-weight: bold;
          border: 1px solid rgba(0, 50, 95, 0.5);
        }
        /deep/ .el-input__icon {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }

    .list {
      user-select: none;
      flex: 1;
      margin-top: 10px; /* [修改] 减小 margin-top */
      .router-link-active {
        color: white;
        background-color: #076fcc;
        .menu-item {
          background: #0763a5;
          span {
            color: #ffffff;
          }
          p {
            color: #cce4ff !important;
          }
        }
      }
      .query {
        margin-top: 10px;
        padding-left: 20px;
        width: 280px;
        height: 60px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 10px 10px 0px 0px;
        img {
          width: 16px;
          height: 16px;
          line-height: 60px;
        }
        span {
          margin-left: 10px;
          font-size: 20px;
          font-family: MicrosoftYaHei-, MicrosoftYaHei;
          font-weight: normal;
          color: #00325f;
          line-height: 60px;
        }
      }
      .menu-item {
        margin-top: 2px;
        padding-left: 36px;
        width: 280px;
        height: 60px;
        background: rgba(255, 255, 255, 0.8);
        span {
          margin-left: 10px;
          font-size: 20px;
          font-family: KaiTi-, KaiTi;
          font-weight: normal;
          color: #00325f;
          line-height: 60px;
        }

        p.tip {
          font-size: 14px;
          color: #0051ff;
          line-height: 1.3;
          margin-top: -18px;
          i {
            margin-right: 4px;
          }
        }
        &:hover {
          span {
            color: #ffffff;
          }
          background: #0763a5;
          p.tip {
            color: #cce4ff;
          }
        }
      }
      .history {
        border-radius: 0px 0px 10px 10px;
      }
    }
  }
  .content-container {
    height: 100%;
    flex: 1;
  }
}
</style>
